import { z } from 'zod';
import { PAGE_SIZE_DEFAULT, PAGE_SIZE_MAX } from './query/ast';

/** Query-string pagination for list endpoints (values arrive as strings; coerced). */
export const PageQuerySchema = z.object({
  pageSize: z.coerce.number().int().min(1).max(PAGE_SIZE_MAX).default(PAGE_SIZE_DEFAULT),
  cursor: z.string().max(4096).optional(),
});
export type PageQuery = z.infer<typeof PageQuerySchema>;

export interface Page<T> {
  items: T[];
  /** Opaque keyset cursor for the next page; null when this is the last page. */
  nextCursor: string | null;
}

export const pageOf = <T>(items: T[], nextCursor: string | null): Page<T> => ({
  items,
  nextCursor,
});
